export default __webpack_public_path__ + "static/media/prism_transparent.9abab8db.png";